var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "133px",
    height: "25px",
    viewBox: "0 0 133 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_becken_sem_assinatura") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "becken",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    transform: "translate(-165.000000, -88.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENU"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_becken_sem_assinatura",
    transform: "translate(165.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5442409,12.1370812 C43.5442409,19.4080046 48.4230436,24.2661012 55.2607525,24.2661012 C57.4534121,24.3446143 59.6113069,23.6996281 61.404259,22.4298315 L61.404259,17.4938719 C59.7907262,18.97546 57.6750144,19.7830576 55.4887684,19.7518996 C51.264473,19.7518996 48.5015106,16.7272919 48.5015106,12.1361543 C48.5015106,7.50145041 51.264473,4.48240432 55.4887684,4.48240432 C57.6794759,4.46542445 59.7944898,5.2863437 61.404259,6.77843661 L61.404259,1.842477 C59.6107368,0.573860607 57.4532467,-0.0710046045 55.2607525,0.0062073325 C48.4230436,0.00528039173 43.5442409,4.86523086 43.5442409,12.1370812 Z",
    id: "logo-path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "logo-path",
    points: "37.9361564 9.76411284 34.7799357 9.76411284 31.2369187 13.9353463 37.9361564 13.9353463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3628156,11.7542547 C16.6844069,12.5546021 18.2332164,14.7595853 18.2049304,17.2241322 C18.2049304,21.5483109 15.2084132,23.8851285 10.2936079,23.8851285 L0.5,23.8851285 L0.5,0.389033871 L9.52370795,0.389033871 C14.4394363,0.389033871 17.4738024,2.56919857 17.4738024,6.77936355 C17.5982483,8.9338198 16.3494469,10.9308232 14.3628156,11.7542547 Z M5.22371495,4.52411665 L5.22371495,4.51948195 L5.22371495,10.0375604 L9.21630184,10.0375604 C11.5610812,10.0375604 12.7897825,9.11896206 12.7897825,7.241907 C12.7897825,5.36485193 11.5610812,4.52411665 9.21630184,4.52411665 L5.22371495,4.52411665 Z M9.86988601,19.7565344 L9.86896286,19.7518996 C12.1749703,19.7518996 13.4027484,18.6015662 13.4036716,16.804228 C13.4036716,14.9698122 12.1777397,13.8574833 9.86988601,13.8574833 L5.22371495,13.8574833 L5.22371495,19.7565344 L9.86988601,19.7565344 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "logo-path",
    points: "86.5432478 0.389033871 80.6286803 0.389033871 72.0250017 10.4926883 72.0250017 0.389033871 67.1083502 0.389033871 67.1083502 23.8851285 72.0250017 23.8851285 72.0250017 13.2466293 80.8576194 23.8851285 86.8866564 23.8851285 76.7514861 11.6374601"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "logo-path",
    points: "127.778131 0.389033871 127.778131 15.2349173 117.369711 0.389033871 112.761389 0.389033871 112.761389 23.8851285 117.485104 23.8851285 117.485104 8.23280668 128.622806 23.8851285 132.5 23.8851285 132.5 0.389033871 127.776285 0.389033871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "logo-path",
    points: "23.2277432 23.8851285 39.245171 23.8851285 39.245171 19.559096 28.0686971 19.559096 28.0686971 14.2987071 28.0686971 14.2987071 28.0686971 9.36460136 28.0686971 9.36460136 28.0686971 4.67335412 39.245171 4.67335412 39.245171 0.389033871 23.2277432 0.389033871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "logo-path",
    points: "105.703972 9.76318589 102.545905 9.76318589 99.0038115 13.9344194 105.703972 13.9344194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "logo-path",
    points: "90.9955591 23.8851285 107.012987 23.8851285 107.012987 19.559096 95.836513 19.559096 95.836513 14.2987071 95.836513 14.2987071 95.836513 9.36460136 95.836513 9.36460136 95.836513 4.67335412 107.012987 4.67335412 107.012987 0.389033871 90.9955591 0.389033871"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.8a2a37e9dbaa37b22b8ffcaa31e8aade.svg";
export { ForwardRef as ReactComponent };